export const config = {
	TRPC_URL: '/trpc',
	SUPABASE_URL: process.env.SUPABASE_URL || 'https://jclxwzbylxakraflrdje.supabase.co',
	SUPABASE_ANON:
		process.env.SUPABASE_ANON ||
		'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpjbHh3emJ5bHhha3JhZmxyZGplIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjY2MzYxMzgsImV4cCI6MTk4MjIxMjEzOH0.o9rDmjPAJhRKgM9Ddaw69jej0LEDntR9bPhxmRaY7ZY',
	SERVIS_MANUAL_URL: 'https://wiki.infigy.cz/Technick-wiki-Infigy-10e7c10ecadd4495b4274b72ac3d8650?pvs=4',
	USER_MANUAL_URL: 'https://wiki.infigy.cz',
	SERVIS_PHONE_NUMBER: '+420234261711',
	SERVIS_EMAIL: 'info@infigy.cz',

	FIREBASE_API_KEY: 'AIzaSyBuXAUCbMYjkOWwEeKBvNz_U1NV4YTDUHQ',
	FIREBASE_AUTH_DOMAIN: 'infigy.firebaseapp.com',
	FIREBASE_PROJECT_ID: 'infigy',
	FIREBASE_STORAGE_BUCKET: 'infigy.appspot.com',
	FIREBASE_MESSAGING_SENDER_ID: '399738529743',
	FIREBASE_APP_ID: '1:399738529743:web:4db2940fd',
	FIREBASE_VAPID_KEY: 'BMlEcuBvIx8inzznoAr2mm050A-I7gh3aw7FeGs6-Tm7PLPEwpJxbUKDNa5pksV88_d43n2RnZkJXJMWLsxFw8o',
};
